import _regeneratorRuntime from "D:\\agent\\_work\\82\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import axios from "axios";
import config from "./config";
import { HospitalAlertTypes } from "./enums";
import { getApiHeader } from "./token";
export var getHeaderAlert = function getHeaderAlert(hospitalCode) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var response, result;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return axios.get("api/Samples/".concat(hospitalCode, "/notification?"), getApiHeader());
          case 2:
            response = _context.sent;
            result = response.data;
            return _context.abrupt("return", result);
          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
};
var getDashboardInfo = function getDashboardInfo(hospitalCode) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var response, result;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return axios.get("api/Samples/".concat(hospitalCode, "/dashboard"), getApiHeader());
          case 2:
            response = _context2.sent;
            result = response.data;
            return _context2.abrupt("return", result);
          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
};
var getRecentSamples = function getRecentSamples(hospitalCode, noOfResults) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var response, result;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return axios.get("api/Samples/".concat(hospitalCode, "/top/").concat(noOfResults), getApiHeader());
          case 2:
            response = _context3.sent;
            result = response.data;
            return _context3.abrupt("return", result);
          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
};
export var getSamplesv2 = function getSamplesv2(code, statuses, pageNumber, pageSize, orderBy, isAscending, keyword, filters) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    var page, top, index, ascendingFilter, statusQuery, response;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            page = pageNumber || 1;
            top = pageSize || 25;
            index = page - 1;
            keyword = keyword || "";
            orderBy = orderBy || "";
            ascendingFilter = isAscending ? "true" : "false"; //use onlineOrderStatus for API call, keep sampleStatus to not change URL
            if (orderBy) {
              if (orderBy.toLocaleLowerCase() === "samplestatus") {
                orderBy = "onlineOrderStatus";
              } else if (orderBy.toLocaleLowerCase() === "orderdate") {
                orderBy = "orderedDate";
              }
            }
            statusQuery = "";
            statuses.forEach(function (status) {
              statusQuery += "&onlineOrderingStatuses=".concat(status);
            });
            _context4.next = 11;
            return axios.get("api/Samples/".concat(code, "?index=").concat(index, "&pageSize=").concat(top, "&orderBy=").concat(orderBy, "&isAscending=").concat(ascendingFilter).concat(statusQuery, "&keyword=").concat(keyword, "&searchPanelOrders=true").concat(filters ? "&filters=" + encodeURIComponent(filters) : ""), getApiHeader());
          case 11:
            response = _context4.sent;
            return _context4.abrupt("return", response.data);
          case 13:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
};
export var getSampleById = function getSampleById(hospitalCode, sampleId) {
  var searchFromTemp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return axios.get("api/Samples/".concat(hospitalCode, "/").concat(sampleId, "?searchFromTemp=").concat(searchFromTemp), getApiHeader()).then(function (res) {
              return res;
            }).catch(function (error) {
              return error;
            });
          case 2:
            return _context5.abrupt("return", _context5.sent);
          case 3:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
};
export var getTempSampleById = function getTempSampleById(sampleId) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return axios.get("api/Samples/tempSamples/".concat(sampleId), getApiHeader()).then(function (res) {
              return res.data;
            }).catch(function (error) {
              return error;
            });
          case 2:
            return _context6.abrupt("return", _context6.sent);
          case 3:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
};
var getTempSampleReferrals = function getTempSampleReferrals(sampleId) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
    var options, response;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            options = getApiHeader();
            _context7.next = 3;
            return axios.get("api/samples/tempSamples/".concat(sampleId, "/referrals"), options);
          case 3:
            response = _context7.sent;
            return _context7.abrupt("return", response.data);
          case 5:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
};
export var getSampleByIdv2 = function getSampleByIdv2(hospitalCode, sampleId) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return axios.get("api/Samples/v2/".concat(hospitalCode, "/").concat(sampleId), getApiHeader()).then(function (res) {
              return res;
            }).catch(function (error) {
              return error;
            });
          case 2:
            return _context8.abrupt("return", _context8.sent);
          case 3:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
};
export var patchSampleShippingInfo = function patchSampleShippingInfo(hospitalCode, sampleId, shipCarrierToBG, shipTrackingNoToBG, isAccessioned) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.next = 2;
            return axios.put("api/Samples/".concat(hospitalCode, "/").concat(sampleId), {
              shipCarrierToBG: shipCarrierToBG,
              shipTrackingNoToBG: shipTrackingNoToBG,
              isAccessioned: isAccessioned
            }, getApiHeader()).then(function (res) {
              return res;
            }).catch(function (error) {
              return error;
            });
          case 2:
            return _context9.abrupt("return", _context9.sent);
          case 3:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
};
var getReport = function getReport(code, sampleId) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee0() {
    var options, response;
    return _regeneratorRuntime.wrap(function _callee0$(_context0) {
      while (1) {
        switch (_context0.prev = _context0.next) {
          case 0:
            options = getApiHeader();
            options.responseType = "blob";
            _context0.next = 4;
            return axios.get("api/samples/".concat(code, "/").concat(sampleId, "/report"), options);
          case 4:
            response = _context0.sent;
            return _context0.abrupt("return", response.data);
          case 6:
          case "end":
            return _context0.stop();
        }
      }
    }, _callee0);
  }));
};
var downloadReport = function downloadReport(payload) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee1() {
    var options, response;
    return _regeneratorRuntime.wrap(function _callee1$(_context1) {
      while (1) {
        switch (_context1.prev = _context1.next) {
          case 0:
            options = getApiHeader();
            options.responseType = "blob";
            _context1.next = 4;
            return axios.post("api/samples/reports/multi-reported", payload, options);
          case 4:
            response = _context1.sent;
            return _context1.abrupt("return", response.data);
          case 6:
          case "end":
            return _context1.stop();
        }
      }
    }, _callee1);
  }));
};
var getReportList = function getReportList(sampleId) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
    var options, response;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            options = getApiHeader();
            options.responseType = "json";
            _context10.next = 4;
            return axios.get("api/samples/".concat(sampleId, "/sample-reports"), options);
          case 4:
            response = _context10.sent;
            return _context10.abrupt("return", response.data);
          case 6:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));
};
var getFileList = function getFileList(code, sampleId) {
  var isTempSample = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
    var options, response;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            options = getApiHeader(); // options.responseType = "blob";
            _context11.next = 3;
            return axios.get("api/samples/".concat(code, "/").concat(sampleId, "/files?isTempSample=").concat(isTempSample), options);
          case 3:
            response = _context11.sent;
            return _context11.abrupt("return", response.data);
          case 5:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));
};
var getFile = function getFile(code, sampleId, path, documentManagementId) {
  var isTempSample = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
    var options, response;
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            options = getApiHeader();
            options.responseType = "blob";
            _context12.next = 4;
            return axios.get("api/samples/".concat(code, "/").concat(sampleId, "/file-download?isTempSample=").concat(isTempSample, "&path=").concat(path ? path : "").concat(documentManagementId ? "&documentManagementId=".concat(documentManagementId) : ""), options);
          case 4:
            response = _context12.sent;
            return _context12.abrupt("return", response.data);
          case 6:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }));
};
var generateReq = function generateReq(code, sampleId, isTempSample) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
    var options, url, response;
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            options = getApiHeader();
            options.responseType = "blob";
            url = "api/samples/".concat(code, "/").concat(sampleId, "/req");
            if (isTempSample) {
              url += "?isTempSample=true";
            }
            _context13.next = 6;
            return axios.get(url, options);
          case 6:
            response = _context13.sent;
            return _context13.abrupt("return", response.data);
          case 8:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  }));
};
var getTreatmentRecommendations = function getTreatmentRecommendations(code, sampleId, physicianId) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
    var options, url, response;
    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            options = getApiHeader();
            url = "api/samples/".concat(code, "/").concat(sampleId, "/treatment-recommendation");
            if (physicianId !== undefined) {
              url += "?physicianId=".concat(physicianId);
            }
            // options.responseType = "blob";
            _context14.next = 5;
            return axios.get(url, options);
          case 5:
            response = _context14.sent;
            return _context14.abrupt("return", response.data);
          case 7:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14);
  }));
};
var getTreatmentGuidancebyId = function getTreatmentGuidancebyId(id) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
    var response;
    return _regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            _context15.next = 2;
            return axios.get("api/Treatment/".concat(id), {
              baseURL: config.apiUrl
            });
          case 2:
            response = _context15.sent;
            return _context15.abrupt("return", response.data);
          case 4:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15);
  }));
};
var addTreatmentLastViewed = function addTreatmentLastViewed(treatmentLastViewedDTOs) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
    var response;
    return _regeneratorRuntime.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            _context16.next = 2;
            return axios.post("api/treatment/last-viewed", treatmentLastViewedDTOs, getApiHeader());
          case 2:
            response = _context16.sent;
            return _context16.abrupt("return", response.data);
          case 4:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16);
  }));
};
var addTestToSample = function addTestToSample(sampleId, request, isReflex, labNumber, isReanalysis) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee17() {
    var response;
    return _regeneratorRuntime.wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            _context17.next = 2;
            return axios.post("api/samples/".concat(request.hospitalCode, "/").concat(sampleId, "/add-test?isReflex=").concat(isReflex, "&labNumber=").concat(labNumber, "&isReanalysis=").concat(isReanalysis), request, getApiHeader());
          case 2:
            response = _context17.sent;
            return _context17.abrupt("return", response.data);
          case 4:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee17);
  }));
};
var getRelatedSampleTests = function getRelatedSampleTests(code, sampleId) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee18() {
    var options, response;
    return _regeneratorRuntime.wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            options = getApiHeader();
            _context18.next = 3;
            return axios.get("api/samples/".concat(code, "/").concat(sampleId, "/related-tests"), options);
          case 3:
            response = _context18.sent;
            return _context18.abrupt("return", response.data);
          case 5:
          case "end":
            return _context18.stop();
        }
      }
    }, _callee18);
  }));
};
var getSampleReferrals = function getSampleReferrals(sampleId) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee19() {
    var options, response;
    return _regeneratorRuntime.wrap(function _callee19$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            options = getApiHeader();
            _context19.next = 3;
            return axios.get("api/samples/".concat(sampleId, "/referrals"), options);
          case 3:
            response = _context19.sent;
            return _context19.abrupt("return", response.data);
          case 5:
          case "end":
            return _context19.stop();
        }
      }
    }, _callee19);
  }));
};
var getSampleAddonRequests = function getSampleAddonRequests(sampleId) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee20() {
    var options, response;
    return _regeneratorRuntime.wrap(function _callee20$(_context20) {
      while (1) {
        switch (_context20.prev = _context20.next) {
          case 0:
            options = getApiHeader();
            _context20.next = 3;
            return axios.get("api/samples/".concat(sampleId, "/availability-requests"), options);
          case 3:
            response = _context20.sent;
            return _context20.abrupt("return", response.data);
          case 5:
          case "end":
            return _context20.stop();
        }
      }
    }, _callee20);
  }));
};
var postSampleAddonRequests = function postSampleAddonRequests(code, availabilityRequests) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee21() {
    var sampleId, response;
    return _regeneratorRuntime.wrap(function _callee21$(_context21) {
      while (1) {
        switch (_context21.prev = _context21.next) {
          case 0:
            if (!(availabilityRequests !== undefined && availabilityRequests.length > 0)) {
              _context21.next = 6;
              break;
            }
            sampleId = availabilityRequests[0].sampleId;
            _context21.next = 4;
            return axios.post("api/samples/".concat(code, "/").concat(sampleId, "/request-addon-availability"), availabilityRequests, getApiHeader());
          case 4:
            response = _context21.sent;
            return _context21.abrupt("return", response.data);
          case 6:
          case "end":
            return _context21.stop();
        }
      }
    }, _callee21);
  }));
};
var patchSetAddonRequestAsOrdered = function patchSetAddonRequestAsOrdered(requestId) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee22() {
    var response;
    return _regeneratorRuntime.wrap(function _callee22$(_context22) {
      while (1) {
        switch (_context22.prev = _context22.next) {
          case 0:
            _context22.next = 2;
            return axios.patch("api/samples/availability-request/".concat(requestId, "/mark-ordered"), {}, getApiHeader());
          case 2:
            response = _context22.sent;
            return _context22.abrupt("return", response.data);
          case 4:
          case "end":
            return _context22.stop();
        }
      }
    }, _callee22);
  }));
};
var getFilters = function getFilters(hospitalCode, type, institutionCodes) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee23() {
    var response, result;
    return _regeneratorRuntime.wrap(function _callee23$(_context23) {
      while (1) {
        switch (_context23.prev = _context23.next) {
          case 0:
            _context23.next = 2;
            return axios.get("api/Samples/GetOrderHistoryFilter?&hospitalCode=".concat(hospitalCode, "&status=").concat(type, "\n    &institutionCodes=").concat(institutionCodes.join(",")), getApiHeader());
          case 2:
            response = _context23.sent;
            result = response.data;
            return _context23.abrupt("return", result);
          case 5:
          case "end":
            return _context23.stop();
        }
      }
    }, _callee23);
  }));
};
var checkDuplicateOrder = function checkDuplicateOrder(object) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee24() {
    var response;
    return _regeneratorRuntime.wrap(function _callee24$(_context24) {
      while (1) {
        switch (_context24.prev = _context24.next) {
          case 0:
            _context24.next = 2;
            return axios.post("api/Samples/DuplicateOrderCheck", object, getApiHeader());
          case 2:
            response = _context24.sent;
            return _context24.abrupt("return", response.data);
          case 4:
          case "end":
            return _context24.stop();
        }
      }
    }, _callee24);
  }));
};
export default {
  getDashboardInfo: getDashboardInfo,
  getRecentSamples: getRecentSamples,
  getHeaderAlert: getHeaderAlert,
  getSampleById: getSampleById,
  patchSampleShippingInfo: patchSampleShippingInfo,
  getSamplesv2: getSamplesv2,
  getTempSampleById: getTempSampleById,
  getTempSampleReferrals: getTempSampleReferrals,
  getReport: getReport,
  getSampleByIdv2: getSampleByIdv2,
  getFileList: getFileList,
  getFile: getFile,
  generateReq: generateReq,
  getTreatmentRecommendations: getTreatmentRecommendations,
  addTreatmentLastViewed: addTreatmentLastViewed,
  addTestToSample: addTestToSample,
  getRelatedSampleTests: getRelatedSampleTests,
  getSampleReferrals: getSampleReferrals,
  getTreatmentGuidancebyId: getTreatmentGuidancebyId,
  getSampleAddonRequests: getSampleAddonRequests,
  postSampleAddonRequests: postSampleAddonRequests,
  patchSetAddonRequestAsOrdered: patchSetAddonRequestAsOrdered,
  getFilters: getFilters,
  checkDuplicateOrder: checkDuplicateOrder,
  getReportList: getReportList,
  downloadReport: downloadReport
};